import { render, staticRenderFns } from "./dentistrySix.vue?vue&type=template&id=226949f0&scoped=true"
import script from "./dentistrySix.vue?vue&type=script&lang=js"
export * from "./dentistrySix.vue?vue&type=script&lang=js"
import style0 from "./dentistrySix.vue?vue&type=style&index=0&id=226949f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "226949f0",
  null
  
)

export default component.exports